const transformOrigin = {
    name: "transform-origin",
    path: "/transform-origin",
    title: "transform-origin",
    description: "Utilities for controlling the CSS transform-origin property.",
    value: {
        "transform-origin": {
            "origin-center": "center",
            "origin-top": "top",
            "origin-bottom": "bottom",
            "origin-left": "left",
            "origin-right": "right",
            "origin-top-left": "top left",
            "origin-top-right": "top right",
            "origin-bottom-left": "bottom left",
            "origin-bottom-right": "bottom right",
            "origin-[<value>]": "<value>",
        }
    },
    exampleData: [
        {
            example: {
                code: `<img class="origin-center rotate-45 ..." src="/img/mountains.jpg" />
<img class="origin-top-left rotate-12 ..." src="/img/mountains.jpg" />
<img class="origin-bottom -rotate-12 ..." src="/img/mountains.jpg" />
<img class="origin-[0%_100%] -rotate-12 ..." src="/img/mountains.jpg" />`
            }
        }
    ],
    htmlData: [
        {
            title: "Transform origin",
            data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-6">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">origin-*</code> utilities to set the <code>transform-origin</code> of an element.
      </p>
      <div class="flex gap-8 items-end mb-6 justify-around">
        <div class="flex flex-col items-center">
          <span class="mb-10 text-xs text-color-gray-500">origin-center</span>
          <div class="relative">
            <div class="absolute inset-0">
                <img class="size-32 opacity-25 rounded-lg object-cover opacity-25" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"/>
            </div>
            <img class="rotate-45 origin-center size-32 rounded-lg shadow-lg" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo" alt="mountains" />
          </div>
          </div>
        <div class="flex flex-col items-center">
          <span class="mb-10 text-xs text-color-gray-500">origin-top-left</span>
          <div class="relative">
           <div class="absolute inset-0">
                <img class="size-32 opacity-25 rounded-lg object-cover opacity-25" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"/>
            </div>
            <img class="rotate-12 origin-top-left size-32 rounded-lg shadow-lg" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo" alt="mountains" />
          </div>
        </div>
        <div class="flex flex-col items-center">
          <span class="mb-10 text-xs text-color-gray-500">origin-bottom</span>
          <div class="relative">
           <div class="absolute inset-0">
                <img class="size-32 opacity-25 rounded-lg object-cover opacity-25" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"/>
            </div>
            <img class="-rotate-12 origin-bottom size-32 rounded-lg shadow-lg" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo" alt="mountains" />
          </div>
        </div>
        <div class="flex flex-col items-center">
          <span class="mb-10 text-xs text-color-gray-500">origin-[]</span>
          <div class="relative">
           <div class="absolute inset-0">
                <img class="size-32 opacity-25 rounded-lg object-cover opacity-25" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"/>
            </div>
            <img class="-rotate-12 origin-[0%_100%] size-32 rounded-lg shadow-lg" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo" alt="mountains" />
          </div>
        </div>
      </div>
      `
        }
    ]
};

export default transformOrigin;
<div className="origin-top-left origin-[0%_100%] origin-bottom rotate-12 -rotate-12"></div>